module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Vertical-18843112d5a3bf02dc7074179576e089.svg";